<div class="h-lg-100 d-flex flex-column overflow-lg-hidden">
  <div class="flex-fill overflow-lg-hidden">
    <div class="h-100 row">
      <div class="col col-md h-100">
        <div class="bg-white h-100 d-flex flex-column">
          <div class="d-flex flex-wrap align-items-center gap-2 mb-3 flex-wrap">
            <h2 class="mb-0">
              <i class="bi fs-24 bi-map me-1"></i>
              Project Map
            </h2>
            <div class="ms-auto d-flex align-items-center gap-4 flex-wrap justify-content-end">
              <div class="d-flex flex-wrap align-items-center gap-3">
                <span class="fw-500 fs-16 me-3">Lot Status:</span>

                <div class="d-flex align-items-center gap-2">
                  <div class="map-legend" [style.background-color]="lotStatusColors.Open"></div>
                  <span>Open</span><span>({{ openLotsCount() }})</span>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <div class="map-legend" [style.background-color]="lotStatusColors.Reserved"></div>
                  <span>Reserved</span><span>({{ reservedLotsCount() }})</span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <div class="map-legend" [style.background-color]="lotStatusColors.ScheduledReserved"></div>
                  <span>Scheduled Reserved</span><span>({{ scheduledReservedLots().length }})</span>
                </div>

                <div class="d-flex align-items-center gap-2">
                  <div class="map-legend" [style.background-color]="lotStatusColors.Offer"></div>
                  <span>Offer</span><span>({{ offerLotsCount() }})</span>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <div class="map-legend" [style.background-color]="lotStatusColors.Sold"></div>
                  <span>Sold</span><span>({{ soldLotsCount() }})</span>
                </div>
              </div>
              @if (!_projectService.disabled()) {
                @if (mapImageUrl()) {
                  <button class="btn btn-h42 btn-outline-danger" (click)="showConfirmPopup()">
                    <i class="bi bi-trash"></i>
                    Clear Map
                  </button>
                }
                @if (!mapImageUrl()) {
                  <button class="btn btn-h42 btn-outline-primary" (click)="uploadMapImage()">
                    <i class="bi bi-upload"></i>
                    Upload Map
                  </button>
                  <input type="file" (change)="onFileSelected($event)" accept="image/*" style="display: none" />
                }
              }
            </div>
          </div>
          @if (!_projectService.disabled() || mapImageUrl()) {
            <div
              class="flex-fill map-container-wrapper"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)"
              [class.drag-over]="isDragOver()"
            >
              @if (!mapImageUrl()) {
                <div class="drag-overlay">
                  <div class="drag-overlay-content">
                    <i class="bi bi-cloud-upload fs-48 text-primary"></i>
                    <p class="text-primary mb-0 fs-18 fw-500">Drop image here</p>
                    <small class="text-muted">Release to load the image</small>
                  </div>
                </div>
              }
              <app-map
                [mapCoordinates]="coordinates()"
                [imageUrl]="mapImageUrl()"
                [zoomMarker]="zoomMarker()"
                [zoomCounter]="zoomCounter()"
              >
              </app-map>
            </div>
          }
        </div>
      </div>
      @if (!_projectService.disabled() || mapImageUrl()) {
        <div class="col-lg-auto col-xl-3 h-lg-100">
          <div class="d-flex flex-column gap-3 h-100 overflow-y-lg-auto pe-3 pt-2">
            <div class="p-3 border rounded-4 bg-white">
              <h3 class="mb-3">
                <i class="bi bi-diagram-3 me-1"></i>
                Mapping Summary
              </h3>

              <div class="d-flex align-items-center gap-3 justify-content-between mb-3 flex-wrap">
                <span
                  class="bg-success-subtle p-3 rounded-3 text-success-emphasis d-flex align-items-center flex-column flex-fill"
                  >Mapped <span class="fw-500"> ({{ mappedLotsCount() }})</span></span
                >
                <span
                  class="bg-danger-subtle p-3 rounded-3 text-danger-emphasis d-flex align-items-center flex-column flex-fill"
                  >Unmapped <span class="fw-500"> ({{ unmappedLotsCount() }})</span></span
                >
              </div>
              <p-progressbar
                [value]="((mappedLotsCount() / coordinates().length) * 100).toFixed(1)"
                [ngClass]="{
                  'progress-red': (mappedLotsCount() / coordinates().length) * 100 <= 30,
                  'progress-yellow':
                    (mappedLotsCount() / coordinates().length) * 100 > 30 &&
                    (mappedLotsCount() / coordinates().length) * 100 < 100,
                  'progress-green': (mappedLotsCount() / coordinates().length) * 100 === 100
                }"
              />
            </div>
            <div class="p-3 border rounded-4 bg-white">
              <div class="d-flex align-items-center gap-2 mb-3">
                <i class="bi bi-geo-alt fs-18"></i>
                <h3 class="mb-0">Mapped Lots</h3>
                <span class="ms-auto fw-500">({{ mappedLotsCount() }})</span>
              </div>
              <div class="position-relative mb-3">
                <svg-icon
                  [name]="'search-topbar'"
                  class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-20"
                ></svg-icon>
                <input
                  class="form-control ps-5 py-2 rounded-5"
                  type="text"
                  [(ngModel)]="mappedSearch"
                  placeholder="Search"
                />
              </div>
              <div class="list-group list-group-flush">
                @for (coordinate of mappedLots(); track $index) {
                  <div class="list-group-item list-group-item-action">
                    <div class="d-flex align-items-center gap-3">
                      <h6 class="mb-0">{{ coordinate.lotNumber }}</h6>
                      <div class="ms-auto d-flex align-items-center gap-2">
                        @if (!_projectService.disabled()) {
                          <i
                            class="bi bi-trash text-danger"
                            (click)="confirmDeleteMapping(coordinate?.lotCoordinateMapping?.id || '')"
                          ></i>
                        }
                        <i
                          class="bi bi-crosshair text-primary"
                          (click)="zoomToMarker(coordinate?.lotCoordinateMapping || null)"
                        ></i>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="p-3 border rounded-4 bg-white">
              <div class="d-flex align-items-center gap-2 mb-3">
                <i class="bi bi-ban fs-18"></i>
                <h3 class="mb-0">Unmapped Lots</h3>
                <span class="ms-auto fw-500">({{ unmappedLotsCount() }})</span>
              </div>
              <div class="position-relative mb-3">
                <svg-icon
                  [name]="'search-topbar'"
                  class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-20"
                ></svg-icon>
                <input
                  class="form-control ps-5 py-2 rounded-5"
                  type="text"
                  [(ngModel)]="unmappedSearch"
                  placeholder="Search"
                />
              </div>

              <div class="list-group list-group-flush">
                @for (coordinate of unmappedLots(); track $index) {
                  <div class="list-group-item list-group-item-action">
                    <div class="d-flex align-items-center gap-3">
                      <h6 class="mb-0">{{ coordinate.lotNumber }}</h6>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
